module.exports = __webpack_public_path__ + "static/media/expii1.7726e524.jpg";